import { PageShell } from "@/components/marketing/PageShell";
import { WithSidePanel } from "@/components/marketing/SidePanel";

const PANEL = {
  id: "dispute",
  img: "/img/people/support.jpg",
  title: "How a dispute works",
  steps: [
    ["Tell us which report", "Enter the report ID and confirm your identity so only you can dispute a report about you."],
    ["Explain what's wrong", "Describe what you believe is incorrect and add any documents that support it."],
    ["We reinvestigate", "A different reviewer looks at the evidence again, by the deadline on your tracking number."],
    ["You get a written outcome", "We send the result to you and to the business that requested the report."],
  ],
  points: ["No account needed to start a dispute", "Each dispute gets a tracking number", "If the result changes, the business is told"],
  link: ["/how-it-works/individuals", "How it works for individuals"],
};
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function DisputeReport() {
  return (
    <PageShell eyebrow="— CONSUMER RIGHTS —" title="Dispute a report">
      <WithSidePanel panel={PANEL}>
      <div className="rounded-3xl border border-gray-200 bg-white p-6 sm:p-8" data-testid="dispute-panel">
        <p className="max-w-2xl text-oath-secondary">
          If a verification report concerns you, you can file a dispute. Enter your
          report ID and verify your identity. Each dispute receives a tracking
          number and a reinvestigation deadline (default 30 days). A written outcome
          is sent to you and to the requesting client.
        </p>
        <form className="mt-8 grid max-w-md gap-5" onSubmit={(e) => e.preventDefault()}>
          <div className="flex flex-col gap-2">
            <Label className="font-mono-label text-[10px] text-oath-secondary">REPORT ID *</Label>
            <Input data-testid="dispute-report-id" placeholder="e.g. RP-RPT-2291-0044" />
          </div>
          <div className="flex flex-col gap-2">
            <Label className="font-mono-label text-[10px] text-oath-secondary">LAST NAME ON RECORD *</Label>
            <Input data-testid="dispute-last-name" placeholder="Identity check" />
          </div>
          <button
            type="submit"
            data-testid="dispute-submit"
            className="mt-2 w-fit rounded-full bg-oath-ink px-6 py-3 font-mono-label text-[11px] font-semibold text-white hover:bg-black"
          >
            START DISPUTE
          </button>
        </form>
        <p className="mt-6 font-mono-label text-[9px] text-oath-muted">
          FULL DISPUTE INTAKE & REINVESTIGATION WORKFLOW ARRIVES IN PHASE 07.
        </p>
      </div>
      </WithSidePanel>
    </PageShell>
  );
}
